export const MESSAGES = {
  REQUEST_ERROR: "Failed to fetch Reporting Tags",
  NO_TAGS_AVAILABLE: "No Reporting Tags",
};

export const ZOHO_TAG_LIST_COLUMNS = [
  "tag_name",
  "tag_id",
  "description",
  "is_active",
  "options_count",
  "actions",
];

export const ZOHO_TAG_LIST_LABELS = {
  tag_name: "Tag Name",
  tag_id: "Tag ID",
  description: "Description",
  is_active: "Is Active",
  options_count: "Total Options",
  actions: "Actions",
};

export const ZOHO_TAG_BOOLEAN_COLUMNS = ["is_active"];
